import i18next from 'i18next';

export const t = i18next.t;

export function bulkTranslation(keysObject) {
    if (!keysObject) {
        throw new Error('bkTranslations: missing keys object');
    }

    return Object.fromEntries(Object.entries(keysObject).map(([key, i18nKey]) => [key, t(i18nKey)]));
}

export function i18nInitialized(callback) {
    if (!i18next.isInitialized) {
        i18next.on('initialized', () => {
            callback();
        });
    } else {
        callback();
    }
}
